module.exports = __webpack_public_path__ + "static/servicecorsal1-bf5f4c2f5c796fd709da99fa3a795ef7.png";